/**
 * @file TeamNames.jsx
 * @description Team logins: "by Maria R." on notes, stage changes and other journal rows,
 *   inside agency views only. One load of the team's names per dashboard (agency_team_names),
 *   shared through context. Solo agencies get an empty label, so nothing changes for them.
 * @module components/team/TeamNames
 */
import { createContext, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { T } from "../../theme";
import { loadTeamNames, attributionLabel } from "../../lib/agencyContext";

const TeamNamesContext = createContext(null);

export function TeamNamesProvider({ enabled = true, children }) {
  const [names, setNames] = useState(null);
  useEffect(() => {
    if (!enabled) { setNames(null); return; }
    let live = true;
    loadTeamNames().then((m) => { if (live) setNames(m); });
    return () => { live = false; };
  }, [enabled]);
  return <TeamNamesContext.Provider value={names}>{children}</TeamNamesContext.Provider>;
}

export const useTeamNames = () => useContext(TeamNamesContext);

/** " · by Maria R." after a timestamp, or nothing. */
export function ByLine({ userId, style }) {
  const { t } = useTranslation();
  const names = useTeamNames();
  const label = attributionLabel(names, userId);
  if (!label) return null;
  return <span style={{ color: T.textLight, ...style }}>{" · "}{t("team.by", { name: label })}</span>;
}
